import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  Tooltip,
  TableCell,
  Collapse,
  TableRow,
  Button,
} from "@material-ui/core";
import moment from "moment";
import Loading from "../../loading";
import { styles } from "./styles";
import Snackbar from "../../snackbar";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import EditForm from "./edit";
import TableFormat from "../../../partials/TableFormat";
import PriceFormat from "../../../partials/priceFormat";
import Header from "../../../partials/header";
import { formatDatetime } from "../../../utils/setting";

const headCells = [
  {
    key: "isUser",
    numeric: false,
    width: "5%",
    disablePadding: false,
    label: "user_membercard_is_user",
  },
  {
    key: "mobile",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_mobile",
  },
  {
    key: "imgCard",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_img_member_card",
  },
  {
    key: "title",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_title",
  },
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_membercardCode",
  },
  {
    key: "type",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_type",
  },
  {
    key: "balance",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_balance",
  },
  {
    key: "expiredDay",
    numeric: false,
    disablePadding: false,
    label: "user_membercard_expire_day",
  },
];

class UserVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "",
      orderBy: "",
      selected: [],
      collapse: [],
      from: moment().subtract(3, "months").startOf("month").valueOf(),
      to: moment().endOf("month").valueOf(),
    };
  }
  getList = async (data = {}) => {
    let { search, page, rowsPerPage } = this.mTable.state;
    let query = {
      ...this.state,
      ...this.mTable.state,
      limit: rowsPerPage,
      ...data,
    };
    delete query.rowsPerPage;
    if (query.from) {
      query.from = moment(query.from).startOf("day").valueOf();
    }
    if (query.to) {
      query.to = moment(query.to).endOf("day").valueOf();
    }
    this.loading.startLoading();
    await this.props.getList({ snackbar: this.snackbar, ...query });
    this.loading.stopLoading();
  };

  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  isSelected = (id) => {
    return this.state.selected.indexOf(id) !== -1;
  };
  handleCheckbox = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };
  afterEdit = (check) => {
    let { t } = this.props;
    this.handleOpenCollapes(-1);
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("user_voucher_updated_successful"));
      this.setState({
        from: moment().subtract(3, "months").startOf("month").valueOf(),
        to: moment().endOf("month").valueOf(),
        search: "",
      });
      this.getList();
    } else this.mSnackbar.handleClick(check.message);
  };
  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy });
  };
  handleDelete = async (selected) => {
    let { t } = this.props;
    if (selected && selected.length) {
      this.loading.startLoading();
      let check = await this.props.deleteUserMembercard({ _id: selected });
      this.loading.stopLoading();
      if (check && check.code === 1) {
        this.setState({ selected: [] });
        this.snackbar(t("user_membercard_delete_success"));
        return true;
      } else {
        this.snackbar(check.message, "error");
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  };

  handleOpenCollapes = (id) => {
    let { collapse } = this.state;
    collapse = collapse.map((e, index) => {
      if (index !== id) return false;
      else return e;
    });
    collapse[id] = !collapse[id];
    this.setState({ collapse: collapse });
  };
  handleChangeDate = (start, end) => {
    this.setState({
      from: start,
      to: end,
    });
    this.getList({ from: start, to: end });
  };
  handleFilterDate = (from, to) => {
    this.getList({ from: from, to: to });
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const { listUserMembercard = [], classes } = this.props;
    return (
      <TableRow key={index}>
        <TableCell
          colSpan={9}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index] ? true : false} unmountOnExit>
            <EditForm
              item={index}
              data={listUserMembercard.find((e) => e._id === row.id)}
              handleClose={() => this.handleOpenCollapes(index)}
              afterEdit={this.afterEdit}
              {...this.props}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const { classes, t, listUserMembercard = [], total, count } = this.props;
    const { collapse, from, to } = this.state;
    return (
      <div>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Header
          session={t("sidebar_promotion")}
          title={t("sidebar_user_membercard")}
          showFilterDate={true}
          handleFilterDate={this.handleFilterDate}
          from={from}
          to={to}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          placeholder={t(
            "user_membercard_search_by_membercardCode_and_customerMobile"
          )}
          contentDialog={t(
            "user_membercard_do_you_want_to_delete_membercard_of_user"
          )}
          onDelete={this.handleDelete}
          title={t("user_membercard_all_user_membercard")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          rows={listUserMembercard.map((row) => {
            let parsePhone = _parsePhoneNumber(row.countryCode, row.mobile);
            let imgCard = row.memberCard && row.memberCard.image;
            imgCard = imgCard || "/images/noneImage.svg";
            return {
              id: row._id,
              isUser: row.isUser ? (
                <Tooltip title={t("user_voucher_user_is_registered_account")}>
                  <img
                    style={{ width: "1.5rem" }}
                    src="../../../rectangle-logo.png"
                  />
                </Tooltip>
              ) : (
                ""
              ),
              mobile: (
                <div className={classes.customColumn}>
                  <div>
                    {parsePhone.isValid
                      ? parsePhone.format_internal
                      : row.countryCode + "" + row.mobile}
                  </div>
                  <div className={classes.customerNameRow}>
                    {row.customerName}
                  </div>
                </div>
              ),
              imgCard: imgCard && (
                <div>
                  <img className={classes.imgVoucher} src={imgCard} />
                </div>
              ),
              title: row.memberCard && row.memberCard.title,
              code: row.memberCardCode,
              type:
                row.memberCard && row.memberCard.type
                  ? t(row.memberCard.type)
                  : "",
              balance: row.isUnlimitedMoney ? (
                t("membercard_un_specified")
              ) : (
                <PriceFormat value={row.balance} />
              ),
              expiredDay: row.expired
                ? formatDatetime(row.expired)
                : t("membercard_un_specified"),
            };
          })}
        />
      </div>
    );
  }
}

UserVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listUserMembercard: state.userMembercard.listUserMembercard,
  total: state.userMembercard.total,
  count: state.userMembercard.count,
});

const mapDispatch = (dispatch) => ({
  getList: dispatch.userMembercard.getListUserMembercard,
  deleteUserMembercard: dispatch.userMembercard.deleteUserMembercard,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(UserVoucher)
  )
);
